import React from "react";

const CheckedInvoiceSummary = ({
  invoice,
  selectedInvoices,
  setSelectedInvoices,
  paymentType,
  setEftPaymentReq,
  setChequePaymentReq,
}) => {
  // invoice = invoice.invoice;
  return (
    <div>
      <div className="px-[32px] relative">
        <div className="flex flex-row font-[400] leading-[21.79px] pb-[12px] pt-[14px] text-[14px] w-full">
          <div className="w-[55%]">
            <button
              type="button"
              className="block font-[600] font-open-sans leading-[24px] text-[#526D7D] text-[18px] w-fit"
            >
              Invoice #{invoice.original.invoiceID}
            </button>
          </div>
          <div className="text-center w-[13%] ml-3">
            {invoice.original.dealType}
          </div>
          <div className="text-center w-[18%] ml-3">
            {invoice.original.closingDate
              .split(",")
              .map((d) => {
                const [day, month, year] = d.split("/");
                return new Date(year, month - 1, day);
              })
              .sort((a, b) => a - b)[0]
              .toLocaleDateString("en-GB")}
          </div>
          <div className="font-[600] text-center w-[12%]">
            {invoice.original.invoiceTotal}
          </div>
        </div>
      </div>
      <div className="leading-[19px] px-[32px] text-[14px] w-full">
        <div
          className="font-[600]"
          title={((a) => (a.length > 28 ? a : ""))(
            (invoice.original.propertyAddress || "").replace(/<[^>]*>/g, ""),
          )}
        >
          {((a) => {
            const i = a.indexOf(" ", 28);
            return a.length > 28
              ? a.slice(0, i === -1 ? a.length : i) + "..."
              : a;
          })((invoice.original.propertyAddress || "").replace(/<[^>]*>/g, ""))}
        </div>
        {/* <div className="flex gap-[16px] pt-[6px]">
          <div className="font-[600]">Lawyer</div>
          <div className="font-[400]">{invoice.original.lawyerName}</div>
        </div> */}
        <div className="flex gap-[16px] pt-[6px]">
          <div className="font-[600]">Clients</div>
          <div className="flex justify-between w-full">
            <div className="font-[400] max-w-[327px] truncate">
              {invoice.original.clients}
            </div>
            <button
              type="button"
              className="block font-[600] font-open-sans leading-[19.07px] px-[10px] text-[#526D7D] text-[14px] w-[80px]"
              onClick={() => {
                const dataAfterRemove = selectedInvoices.filter(
                  (item) =>
                    item.original.invoiceID != invoice.original.invoiceID,
                );
                const dataLeft = selectedInvoices.filter(
                  (invoice) => invoice.original.paymentMethod === paymentType,
                );
                setSelectedInvoices(dataAfterRemove);
                if (paymentType.includes("EFT") && dataLeft.length == 1) {
                  setEftPaymentReq(false);
                } else if (
                  paymentType.includes("Cheque") &&
                  dataLeft.length == 1
                ) {
                  setChequePaymentReq(false);
                }
              }}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
      <div className="pt-[16px] px-[32px]">
        <hr className="border-line-thick w-full" />
      </div>
    </div>
  );
};

export default CheckedInvoiceSummary;
